/* @flow */

export const PLEASE_ENTER_AT_LEAST_THREE_CHARACTERS: string = 'Please enter at least 3 characters';
export const NO_RESULTS_FOUND: string = 'No Results Found';
